/**
 * @file Web gallery Waldogram related queries.
 */

import gql from 'graphql-tag';

import { WebGalleryAlbumCustomPrintDetails } from '../fragments/custom-prints';

export const AlbumForWaldogramConfiguration = gql`
  query albumForWaldogramConfiguration($id: RecordID!) {
    album(id: $id) {
      id
      custom_prints(slice: { limit: 1 }, custom_print_types: [WALDOGRAM]) {
        records {
          ...WebGalleryAlbumCustomPrintDetails
        }
      }
    }
  }
  ${WebGalleryAlbumCustomPrintDetails}
`;
